import { render, staticRenderFns } from "./task_forwards_footer.vue?vue&type=template&id=8907c1b2&scoped=true"
import script from "./task_forwards_footer.vue?vue&type=script&lang=js"
export * from "./task_forwards_footer.vue?vue&type=script&lang=js"
import style0 from "./task_forwards_footer.vue?vue&type=style&index=0&id=8907c1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8907c1b2",
  null
  
)

export default component.exports